import { useTranslate } from 'react-admin'
import { Box, Typography } from '@mui/material'
import EventIcon from '@mui/icons-material/Event'
import { blue, turquoise } from 'src/assets/colors'
import { getDay } from 'src/components/pages/sales/reservation/helper/getDay'

export const DateProduct = ({ date_in, date_out, date_in_label, date_out_label }) => {
  const translate = useTranslate()

  if (date_in && date_out) {
    return (
      <>
        <Typography variant='h6' component='div' color={blue} margin={'25px 0px 10px 0px'}>
          {translate('ra.title.date')}
        </Typography>
        <Box className='date_reserve_container'>
          <Box className='date_reserve_box'>
            <Typography variant='h7' component='div' fontWeight={600}>
              {date_in_label || translate('ra.field.checkin')}:
            </Typography>

            <Typography variant='h7' component='div' color={turquoise} className='date_reserve_value'>
              <EventIcon /> {getDay(date_in)}
            </Typography>
          </Box>

          <Box className='date_reserve_box'>
            <Typography variant='h7' component='div' fontWeight={600}>
              {date_out_label || translate('ra.field.checkout')}:
            </Typography>

            <Typography variant='h7' component='div' color={turquoise} className='date_reserve_value'>
              <EventIcon /> {getDay(date_out)}
            </Typography>
          </Box>
        </Box>
      </>
    )
  }
}
